import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import qs from 'qs'
import Titulo from '../../comum/Titulo';
import { buscaPedidoGeral } from '../../../actions/pedido/pedidoGeralController';
import { alterouFiltro, FILTRO_SITUACAO_PAGAMENTO, alterouPagina } from '../../../util/filtros';
import {
  PERFIL_ADMIN, PERFIL_ADMIN_EMPRESA, PERFIL_GESTOR_EMPRESA, PERFIL_OPERADOR_EMPRESA
} from '../../../security/securityContext';
import Autorizacao from '../../../security/Autorizacao';
import PedidoGeral from './PedidoGeral';
import { alterouEmpresa } from '../../../actions/empresa/alterarEmpresaSelecionada';
import determinarPaginaAtual from '../../../actions/venda/determinarPaginaAtualVenda'
import cancelarReservasPedido from '../../../actions/reserva/cancelarReservasPedido';
import adicionarFiltroPedido from '../../../actions/pedido/adicionarFiltroPedido';
import limparFiltroPedido from '../../../actions/pedido/limparFiltroPedido'
import PainelFiltragem from './../../pedido/PainelFiltrosPedidos'
import ModalHistoricoPedido from './../ModalHistoricoPedido';
import alterarExibicaoDetalhamentoPedido from '../../../actions/pedido/alterarExibicaoDetalhamentoPedido';
import ModalAlterarFormaPagamento from './../ModalAlterarFormaPagamento';
import ModalInformarComprovante from './../ModalInformarComprovante';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import PaginacaoPedido from './../PaginacaoPedido';
import BotoesPaginacaoPedido from './../BotoesPaginacaoPedido';
import determinaPaginaAtual from '../../../actions/pedido/determinarPaginaAtuaPedido';
import ModalAlteracaoDadosPassageiro from './../ModalAlteracaoDadosPassageiro';
import ModalImpressaoReciboPedido from './../ModalImpressaoReciboPedido';
import ModalConfirmacaoCancelamentoPedido from './../ModalConfirmacaoCancelamentoPedido';
import ModalRealizarPagamentoPendente from './../ModalRealizarPagamentoPendente';
import ModalCancelarEnvioStoneConnect from './../ModalCancelarEnvioStoneConnect';
import { usuarioEmpresaHabilitadoPagamentoViaLink } from '../../../actions/usuario/cadastrarUsuariosEmpresaEmLote';
import ModalHistoricoPassageiro from './../ModalHistoricoPassageiro';

export const CabecalhoTabela = () => (
  <div className="vx-gp-table-header vx-gp-table-header--geral d-none d-lg-grid">
    <div/>
    <div>Pedido</div>
    <div>Empresa</div>
    <div>Vendedor</div>
    <div>Cliente</div>
    <div>Data</div>
    <div>Situação</div>
    <div>Valor</div>
    <div>Pagamento</div>
    <div>Ações</div>
  </div>
);

export class PainelGerenciarPedidos extends React.Component {
  constructor (props) {
    super(props);
    this.montarParametroPedido = this.montarParametroPedido.bind(this);
    this.alterarExibicao = this.alterarExibicao.bind(this);
    this.buscarPedidos = this.buscarPedidos.bind(this);

    this.state = {
      motivoCancelamentoPedido: '',
      custoCancelamento: '0',
      valoresDdiPassageiro: new Map()
    };
  }

  adicionarValoresDdiPassageiro (passageiroId, label) {
    const valores = this.state.valoresDdiPassageiro;
    if (valores.has(passageiroId)) valores.delete(passageiroId);
    valores.set(passageiroId, label);
    this.setState({ valoresDdiPassageiro: valores });
  }

  removerValoresDdiPassageiro (passageiroId) {
    if (this.state.valoresDdiPassageiro.has(passageiroId)) {
      const valores = this.state.valoresDdiPassageiro;
      valores.delete(passageiroId);
      this.setState({ valoresDdiPassageiro: valores });
    }
  }

  limparValoresDdiPassageiro () {
    this.setState({ valoresDdiPassageiro: new Map() });
  }

  UNSAFE_componentWillMount () {
    this.props.determinarPaginaAtual(1);
    this.props.limparFiltroPedido();
  }

  componentDidMount () {
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    this.adicionarParametroNoFiltroPedido(
      FILTRO_SITUACAO_PAGAMENTO.chave,
      FILTRO_SITUACAO_PAGAMENTO.label,
      parametros.situacao
    );
    this.props.usuarioEmpresaHabilitadoPagamentoViaLink(this.props.empresaSelecionada.id);
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps) || alterouFiltro(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
      this.buscarPedidos();
      if (!alterouPagina(this.props, prevProps)) {
        this.props.determinaPaginaAtual(1);
      }
    }
  }

  exibirBotaoEmitirCuṕom () {
    return (
      <div className="vx-gp-toolbar">
        <button className="vx-gp-print-btn" data-toggle="modal" data-target="#modalImpressaoReciboPedido">
          <span className="material-icons">print</span>
          Imprimir Recibo
        </button>
      </div>
    );
  }

  alterarExibicao (pedido) {
    this.props.alterarExibicaoDetalhamentoPedido(pedido);
  }

  adicionarParametroNoFiltroPedido (chave, label, valor) {
    if (valor) {
      this.props.adicionarFiltroPedido({ chave, label, valor });
    }
  }

  buscarPedidos () {
    this.props.buscaPedidoGeral(
      this.props.filtrosAdicionados,
      this.props.paginaAtual,
      this.props.registrosPorPagina,
      this.props.filtrosAdicionados
    );
  }

  montarParametroPedido (values) {
    return {
      id: values.idPedido,
      nome: values.nome,
      telefones: [values.ddd + values.celular],
      email: values.email
    };
  }

  exibirTabelaPedidos () {
    if (this.props.pedidos && this.props.pedidos.length) {
      return (
        <div id='tabela-pedidos'>
          <CabecalhoRodapeTabela
            OpcoesPaginacao={PaginacaoPedido}
            BotoesPaginacao={BotoesPaginacaoPedido}
            pedidos={this.props.pedidos}
            empresaSelecionada={this.props.empresaSelecionada}
          >
            <CabecalhoTabela/>
            <div>
              {this.exibirPedidos()}
            </div>
          </CabecalhoRodapeTabela>
        </div>
      );
    }
    return (
      <div className="vx-gp-empty">
        <span className="material-icons vx-gp-empty-icon">receipt</span>
        <p className="vx-gp-empty-text">Nenhum pedido localizado para os parâmetros informados</p>
      </div>
    );
  }

  exibirPedidos () {
    return this.props.pedidos.map((pedido, index) => (
      <PedidoGeral
        key={pedido.id}
        pedido={pedido}
        empresaSelecionada={this.props.empresaSelecionada}
        alterarExibicao={this.alterarExibicao}
        indice={index}
        valoresDdiPassageiro={this.state.valoresDdiPassageiro}
        adicionarValoresDdiPassageiro={this.adicionarValoresDdiPassageiro.bind(this)}
        removerValoresDdiPassageiro={this.removerValoresDdiPassageiro.bind(this)}
        limparValoresDdiPassageiro={this.limparValoresDdiPassageiro.bind(this)}
      />
    ));
  }

  render () {
    return (
      <Autorizacao
        perfisPermitidos={[PERFIL_ADMIN, PERFIL_OPERADOR_EMPRESA, PERFIL_GESTOR_EMPRESA, PERFIL_ADMIN_EMPRESA]}
        empresaSelecionada={this.props.empresaSelecionada}
      >
        <div>
          <div className="row internas">
            <Titulo texto="Gerenciamento Geral de Pedidos" urlRetorno="/selecao-empresa"/>
            <div className="col-12 filtro-busca">
              <PainelFiltragem/>
            </div>
            <div className='col-12 filtro-busca'>
              {this.exibirBotaoEmitirCuṕom()}
            </div>
            <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
              {this.exibirTabelaPedidos()}
            </div>
          </div>
          <ModalConfirmacaoCancelamentoPedido buscarPedidos={this.buscarPedidos}/>
          <ModalHistoricoPedido/>
          <ModalAlterarFormaPagamento buscarPedidos={this.buscarPedidos}/>
          <ModalRealizarPagamentoPendente buscarPedidos={this.buscarPedidos}/>
          <ModalCancelarEnvioStoneConnect buscarPedidos={this.buscarPedidos}/>
          <ModalInformarComprovante buscarPedidos={this.buscarPedidos}/>
          <ModalAlteracaoDadosPassageiro
            buscarPedidos={this.buscarPedidos}
            valoresDdiPassageiro={this.state.valoresDdiPassageiro}
            adicionarValoresDdiPassageiro={this.adicionarValoresDdiPassageiro.bind(this)}
            removerValoresDdiPassageiro={this.removerValoresDdiPassageiro.bind(this)}
            limparValoresDdiPassageiro={this.limparValoresDdiPassageiro.bind(this)}
          />
          <ModalImpressaoReciboPedido/>
          <ModalHistoricoPassageiro/>
        </div>
      </Autorizacao>
    );
  }
}

export const mapStateToProps = state => ({
  pedido: state.pedido,
  pedidos: state.pedidos.pedidos,
  empresaSelecionada: state.empresaSelecionada,
  filtrosAdicionados: state.filtrosAdicionadosPedido,
  paginaAtual: state.paginaAtualPedido,
  registrosPorPagina: state.registrosPorPaginaPedido,
});

export default connect(mapStateToProps, {
  buscaPedidoGeral,
  cancelarPedido: cancelarReservasPedido,
  determinarPaginaAtual,
  adicionarFiltroPedido,
  limparFiltroPedido,
  alterarExibicaoDetalhamentoPedido,
  determinaPaginaAtual,
  changeFieldValue,
  usuarioEmpresaHabilitadoPagamentoViaLink,
})(PainelGerenciarPedidos)
